import { flow, getRoot, types } from "mobx-state-tree"
import Player from './models/Player'
import { callApi, resolveEndpoint, toastr } from '../utils'

const EditPlayer = types.compose('PLayerEditModel', Player, types.model({}))

const PlayerEditStore = types.model('PlayerEditStore', {

    player: types.maybe(EditPlayer),

}).actions(self => ({

    create(player) {
        self.player = player
    },

    edit(player) {
        self.player = player.serialized
    },

    uploadLogo: flow(function* () {
        if (self.player.config.newLogo) {
            console.log('Uploading file...')

            const formData = new FormData()
            formData.append('file', self.player.config.newLogo)

            try {
                // You can write the URL of your server or any other endpoint used for file upload
                const result = yield fetch(resolveEndpoint('/upload'), {
                    method: 'POST',
                    body: formData,
                })

                const { data: { success, path } } = yield result.json()

                if (success) {
                    return path
                }
            } catch (error) {
            }

            return null
        }
    }),

    bodyWithLogo(serialized, logoPath) {
        if (logoPath) {
            return {
                ...serialized,
                config: {
                    ...serialized.config,
                    logo: logoPath,
                }
            }
        }

        return serialized
    },

    save: flow(function* () {
        const playerId = self.player.id
        const method = self.isNew ? 'POST' : 'PUT'
        const url = self.isNew ? '/players' : `/players/${playerId}`
        const message = self.isNew ? 'Created' : `Saved`
        const path = yield self.uploadLogo()
        const body = self.bodyWithLogo(self.player.serialized, path)

        const { data } = yield callApi({ endpoint: url, method, body })
        getRoot(self).entityStore.add('players', [data])
        self.reset()

        getRoot(self).setPlayer(data.id)

        toastr({ text: message })
    }),

    delete: flow(function* () {
        const playerId = self.player.id
        yield callApi({ endpoint: `/players/${playerId}`, method: 'DELETE' })
        self.reset()
        getRoot(self).entityStore.remove('players', playerId)
        getRoot(self).initSelectedPlayer()

        toastr({ text: 'Deleted' })
    }),

    cancel() {
        self.reset()
        getRoot(self).initSelectedPlayer()
    },

    reset() {
        self.player = undefined
    },

})).views(self => ({

    get isNew() {
        return self.player?.id === -1
    }

}))

export default PlayerEditStore
